<div class="account-info-container" >
    <div class="account-content" (click)="$event.stopPropagation()">

      <div class="account-info">
        <div class="face-img">
          <mat-icon> person_pin</mat-icon>
          <span class="account-name">{{user?.name}}</span>
        </div>
 
        <span class="account-dtl">{{user?.shop_info.name}}</span>
        <span class="account-dtl" style="font-size: 13px;">Last Login : {{user?.lastlogin_date}}</span>
      </div>
    </div>
    <div class="log-sign">
      <!-- <a mat-button  href="#" class="btn-logout" (click)="logout()">Log out</a> -->
      <a mat-menu-item (click)="logout()"><mat-icon>exit_to_app</mat-icon>Sign Out</a>
    </div>
  </div>